module.exports = __webpack_public_path__ + "img/16.55442961.png";